function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPaperclip = function SvgPaperclip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10 2C7.2 2 5 4.2 5 7v8c0 .6-.4 1-1 1s-1-.4-1-1V7c0-3.9 3.1-7 7-7s7 3.1 7 7v8c0 2.8-2.2 5-5 5s-5-2.2-5-5V7c0-1.7 1.3-3 3-3s3 1.3 3 3v8c0 .6-.4 1-1 1s-1-.4-1-1V7c0-.6-.5-1-1-1-.6 0-1 .5-1 1v8c0 1.7 1.3 3 3 3s3-1.3 3-3V7c0-2.8-2.2-5-5-5z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    }
  }));
};
export default SvgPaperclip;